<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="ログイン"
        width="40"
        class="mb30"
      /><br />{{ $t("login") }}
    </h2>
    <div class="account-box">
      <p class="txt-mail">
        <span v-if="!$v.email.required || !$v.email.email">{{
          $t(this.getMessage($v.email, { name: "メールアドレス" }))
        }}</span>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email"
          v-model.trim="$v.email.$model"
        />
      </p>
      <p class="txt-pw">
        <span v-if="!$v.password.required">{{
          $t(this.getMessage($v.password, { name: "パスワード" }))
        }}</span>
        <input
          type="password"
          id="pw"
          name="pw"
          placeholder="Password"
          v-model.trim="$v.password.$model"
        />
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="this.$v.$invalid && this.vaError" />
      <firebaseError :error="this.fbError" :errorCode="errorCode" />
    </p>
    <p class="btn-normal mb30">
      <a class="mousePointer" @click="signIn">{{ $t("login") }}</a>
    </p>
    <p class="btn-normal-2 mb30">
      <router-link
        :to="{
          name: 'Signup',
          params: {
            redirectId: this.$route.params.redirectId,
            pid: this.$route.query.pid,
          },
        }"
        :directive="this"
        v-if="this.$route.params.redirectId"
        >{{ $t("accountCreate") }}</router-link
      >
      <router-link :to="{ name: 'Signup' }" v-else>{{
        $t("accountCreate")
      }}</router-link>
    </p>
    <p class="center mb30">
      <router-link :to="{ name: 'PasswordResetEmailSend' }">{{
        $t("forgotPassword")
      }}</router-link>
    </p>
    <p class="center mb30">
      <router-link :to="{ name: 'Terms' }" target="_blank">
        {{ $t("userTerms") }}</router-link
      >・<a href="https://3platz.jp/#contact" target="_blank">{{
        $t("privacyPolicy")
      }}</a
      >・<a href="https://3platz.jp/point-terms/" target="_blank">{{
        $t("pointTerms")
      }}</a>
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import firebaseError from "@/error/FirebaseError";
import validationError from "@/error/ValidationError";
import { required, email } from "vuelidate/lib/validators";
import redirectEnum from "@/constants/redirectEnum";
//import partnerIdEnum from '@/constants/partnerIdEnum'

export default {
  name: "Signin",
  data() {
    return {
      db: firebase.firestore(),
      email: "",
      password: "",
      redirect: this.$route.query.redirect,
      vaError: false, //バリデーションエラー
      fbError: false, //firebaseエラー
      errorCode: "",
    };
  },
  validations: {
    password: {
      required,
    },
    email: {
      required,
      email,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  methods: {
    async signIn() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.vaError = true;
      } else {
        let redirectId = this.$route.params.redirectId;
        let pid = this.$route.query.pid;
        let source = window.location.href;
        if (pid == "0200001400" && redirectId == "job") {
          source = window.location.href.replace("job", "shopping");
          pid = "0600001400";
          redirectId = "shopping";
        }
        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(async (userCredential) => {
            const logRef = this.db.collection("usersLog").doc();
            await logRef.set({
              uid: userCredential.user.uid,
              type: "signin",
              source: source,
              created_at: firebase.firestore.FieldValue.serverTimestamp(),
            });
            // add phone registration if not already registered
            if (userCredential.user.phoneNumber == null) {
              //redirect to phone verification
              this.$router.push("/account/registerPhone");
            } else {
              if (
                redirectId !== undefined &&
                redirectEnum.redirects[redirectId] !== undefined
              ) {
                await logRef.set({ redirectId: redirectId }, { merge: true });
                if (pid !== undefined) {
                  await logRef.set({ pid: pid }, { merge: true });
                  this.$router.push("/");
                } else {
                  if (
                    redirectEnum.redirects[redirectId].includes("http") &&
                    pid == undefined
                  ) {
                    window.location.href = redirectEnum.redirects[redirectId];
                  } else {
                    this.$router.push({
                      name: "Partner",
                      query: { target: redirectId },
                    });
                    //this.$router.push('/'+redirectEnum.redirects[redirectId]);
                  }
                }
              } else {
                if (this.redirect) {
                  this.$router.push(this.redirect);
                } else {
                  this.$router.push("/");
                }
              }
            }
          })
          .catch((error) => {
            this.errorCode = error.code;
            this.fbError = true;
            return;
          });
      }
    },
  },
};
</script>
